import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Empty trailing cell rendered while column resizing is enabled. It takes whatever width the columns leave free, so
 * resized columns keep exactly the width the user dragged them to instead of sharing out the leftover space. The header
 * row renders it as a `th`, so header and body rows keep one cell per column.
 */
export const TableFillerCell = ({ as: Cell = 'td', className = '' }) => (_jsx(Cell, { "aria-hidden": 'true', className: `nucleus-box-border nucleus-p-0 nucleus-border-solid nucleus-border-0 nucleus-border-b-1 nucleus-border-neutral-200 dark:nucleus-border-neutral-300 ${className}` }));
//# sourceMappingURL=table_filler_cell.js.map